import { ProductOptions } from '@trip-ux/common';
import { PLAN_TYPE } from '@trip-ux/constants';

export const RESET_STORE = 'RESET_STORE';
export const RESET_PAX = 'RESET_PAX';
export const TRANSLATE_DATE_FORMAT = 'TRANSLATE_DATE_FORMAT';

export enum BenefitTypes {
  MANDATORY = 'MANDATORY',
  OPTIONAL = 'OPTIONAL',
  RIDER = 'RIDER'
}

export interface Organization {
  code: string;
  organizationName: string;
  organizationNameInFrench: string;
  category?: string;
  rootOrganization?: boolean;
}
export interface Exclusion {
  exclusionDescription: string;
  maxAge: number;
  minAge: number;
  minCoverage: number;
  maxCoverage: number;
  rateCategory: string[];
  exclusionType: string;
  planCode?: string;
  paxId?: number;
}
export interface ProductContent {
  code: string;
  planType?: PLAN_TYPE;
  benefitType?: BenefitTypes;
  name: string;
  order?: string;
  type?: string;
  summary: string;
  details: string;
  planClass?: string;
  eligibility?: string;
  deductibles: ProductOptions[];
  tripDays: ProductOptions[];
  coverageAmounts?: Record<string, ProductOptions[]>;
  sumInsuredAfterNeeded: boolean;
  mostPopular?: boolean;
  tripCancellation?: string;
  tripInterruption?: string;
  emmergencyMedical?: string;
  travelAccident?: string;
  flightAccident?: string;
  baggageDelay?: string;
  baggageLoss?: string;
  raiders?: string;
  exclusion?: string;
  exclusions?: Exclusion[];
}

export enum STORE {
  MQ = 'mq',
  NA = 'na',
  POLICY_CREATE = 'policy-create',
  POLICY_GETPDF = 'policy-getpdf',
  QUOTE = 'quote',
  QUOTE_FORM = 'quote-form',
  RECOMMENDATION = 'recommendation',
  TRAVELLER_PAYMENTS = 'traveller-payments',
  TRAVELLER_SELECTION = 'traveller-selection',
  TRAVELLER_DETAILS = 'travellers-details',
  TRAVELLER_PLAN = 'travellers-plan'
}

export interface WhitelistAction {
  whitelist?: STORE[];
}
